module.exports = __webpack_public_path__ + "static/media/a1.0ba419b1.jpg";